export default {
    "navigation": {
        "allWatchfaces": "所有应用",
        "faq": "FAQ",
        "helpCenter": "帮助与说明",
        "newsletter": "新闻通讯",
        "contact": "联系",
        "weatherProvider": "天气提供商",
        "tides": "潮汐",
        "colors": "颜色",
        "fonts": "字体"
    },
    "homepage": {
        "title": "TitanicTurtle Apps",
        "subtitle": "现代 Garmin 应用，功能强大，适用于您的所有活动",
        "newBadge": "新",
        "filter": {
            "label": "Product filter",
            "watchfaces": "Watchfaces",
            "apps": "Apps",
            "all": "All",
            "noProducts": "No products in this category"
        }
    },
    "faq": {
        "title": "常见问题",
        "subtitle": "找到关于我们表盘的常见问题答案",
        "tabs": {
            "search": "搜索",
            "categories": "分类",
            "trending": "趋势"
        },
        "search": {
            "placeholder": "搜索帮助...",
            "button": "搜索",
            "suggestions": "热门搜索",
            "tips": {
                "title": "搜索提示",
                "keywords": "使用具体关键词如\"GPS\"、\"天气\"或\"设置\"",
                "language": "搜索在您选择的语言中工作",
                "categories": "浏览分类以获得有组织的帮助"
            }
        },
        "noResults": {
            "title": "未找到结果",
            "description": "尝试不同的关键词或浏览分类",
            "browseCategories": "浏览分类"
        },
        "suggestions": {
            "title": "热门搜索"
        },
        "trending": {
            "title": "趋势搜索"
        },
        "categories": {
            "title": "按分类浏览",
            "items": "项目",
            "allItems": "所有FAQ项目",
            "allItemsDescription": "浏览所有常见问题",
            "noItems": {
                "title": "此分类中没有项目",
                "description": "尝试选择不同的分类"
            },
            "viewMore": "查看所有项目"
        },
        "results": {
            "title": "搜索结果",
            "found": "个结果找到",
            "total": "总结果",
            "bestMatch": "最佳匹配",
            "categories": "分类",
            "sortBy": "排序方式",
            "sort": {
                "relevance": "相关性",
                "priority": "优先级",
                "category": "分类"
            },
            "lastUpdated": "最后更新",
            "matchedIn": "匹配位置",
            "footer": "没有找到您要找的内容？",
            "browseCategories": "浏览分类",
            "viewTrending": "查看趋势",
            "contactSupport": "联系支持"
        },
        "actions": {
            "copy": "复制",
            "share": "分享",
            "copyAnswer": "复制答案",
            "copyAll": "复制全部"
        },
        "loading": "加载FAQ中...",
        "error": "加载错误",
        "retry": "重试"
    },
    "guides": {
        "backToHelp": "返回",
        "purchase": {
            "title": "购买与安装",
            "tabs": {
                "installation": "安装",
                "versions": "VX / Elite 版本",
                "troubleshooting": "故障排除"
            },
            "installation": {
                "title": "通过 ConnectIQ 应用安装表盘",
                "intro": "表盘可通过 Android 或 iOS 的 Garmin ConnectIQ 应用安装到手表上。",
                "step1": "通过蓝牙将手表与手机连接，并在手机上打开 ConnectIQ 应用。",
                "step2": "进入要安装的表盘页面。",
                "step3": "点击「安装」按钮。表盘将加入下载队列并安装到手表上。",
                "step4": "安装完成后，应用或手表会显示提示，表盘即可在设备上使用。",
                "noteScreen": "安装和更新过程中请确保手机屏幕不熄灭，且 ConnectIQ 应用保持打开。",
                "selectWatchfaceTitle": "在手表上选择表盘",
                "selectWatchfaceIntro": "若表盘已安装但尚未显示，可能需要在手表的系统菜单中手动选择。",
                "select1": "长按手表上的菜单键（或触屏设备上的对应按键）以打开系统菜单。",
                "select2": "进入「表盘」或「显示设计」菜单项。",
                "select3": "会看到所有已安装表盘列表。使用上下键或触屏进行选择。",
                "select4": "用右上角按键确认所选表盘。表盘即已在手表上激活。"
            },
            "versions": {
                "title": "VX 与 Elite 有何区别？",
                "sameFeatures": "技术上两个版本相同，功能一致。区别仅在于购买与激活方式。",
                "eliteTitle": "Elite 版本（Garmin Pay）",
                "elite1": "在 ConnectIQ 商店中通过 Garmin Pay 直接购买的表盘需单独安装。",
                "elite2": "Elite 版本与您的 Garmin 账户绑定。更换新手表后，无需额外密钥即可重新安装 Elite 表盘。",
                "elite3": "Garmin Pay 并非所有手表型号都支持，且并非在所有国家/地区可用。",
                "eliteNoKey": "重要：通过 Garmin Pay 购买 Elite 版本时不会发送解锁码。Elite 版本在购买后直接解锁，无需输入代码。",
                "vxTitle": "VX / 网站版本",
                "vx1": "兼容更多设备，在 Garmin Pay 不可用时也常可用。",
                "vx2": "内置数日免费试用期。",
                "vx3": "试用结束后可在此网站购买解锁码，永久解锁 VX 版本（或其专业功能）。",
                "vx4": "解锁码仅对购买时对应的设备（WatchfaceID）有效。",
                "vx5": "若手表在保修期内由 Garmin 换新，可重新生成新密钥。此时请通过联系表单联系支持。"
            },
            "website": {
                "title": "通过网站购买（VX / 普通版本）",
                "step1": "请先在手表上安装表盘（见「安装」标签）。WatchfaceID 仅在安装后才会出现在表盘设置中。",
                "step2": "打开表盘设置（通过 ConnectIQ 应用或 Garmin Express），从顶部字段复制 WatchfaceID。",
                "step3": "在本站选择对应表盘，在购买表单中填入您的 WatchfaceID。",
                "step4": "完成支付。您将收到邮件发送的解锁码，可在表盘设置的密钥栏中输入。",
                "noteNoAutoInstall": "重要：通过网站购买解锁码不会自动在手表上安装表盘。上述安装步骤需手动完成。"
            },
            "troubleshooting": {
                "installationTitle": "安装问题（队列 / 更新卡住）",
                "installationIntro": "有时安装失败、表盘长时间停留在队列，或 ConnectIQ 应用一直提示更新。",
                "installationCause": "这通常与 ConnectIQ 应用或 Garmin 服务有关，而非表盘本身。",
                "installationFix1": "重启手表，并重启手机上的 ConnectIQ 应用。",
                "installationFix2": "重新尝试安装，并确保过程中手机屏幕不熄灭、ConnectIQ 应用保持打开。",
                "garminPayTitle": "Garmin Pay 购买一直显示「处理中」",
                "garminPayText": "若 ConnectIQ 商店中的 Garmin Pay 购买长时间处于「处理中」，完全由 Garmin 处理。作为开发者无法干预 Garmin Pay 系统。此时请联系 Garmin 官方支持。",
                "noKeyTitle": "网站购买后未收到解锁密钥",
                "noKey1": "请先查看邮箱的垃圾邮件文件夹。带密钥的邮件常被归入此处。",
                "noKey2": "很多情况是邮箱地址拼写错误导致未送达。若找不到邮件，请联系我们。",
                "noKey3": "并注明您用于支付的邮箱地址，如有可能请提供 WatchfaceID。",
                "noKeyElite": "说明：在 ConnectIQ 商店中通过 Garmin Pay 直接购买 Elite 版本时不会发送解锁码。Elite 版本在购买后立即解锁，无需代码。"
            },
            "contactLink": "联系表单"
        },
        "timezones": {
            "title": "时区与 UTC 偏移",
            "basicsTitle": "第二、第三时区是什么？",
            "basicsText": "许多表盘可设置两个附加时区，通常称为「第二时区」和「第三时区」，在表盘上的专用字段中显示。",
            "offsetTitle": "配置 UTC 偏移",
            "offsetIntro": "表盘设置中通常有一个字段，可输入第二、第三时区相对 UTC 的分钟偏移。",
            "offsetFormat": "第一个值为第二时区偏移，第二个为第三时区偏移。单位为分钟，用空格分隔。正数不会自动加 +，需自行输入正号。",
            "exampleLabel": "示例：",
            "exampleExplanation": "此处第二时区为 -4.5 小时（−270 分钟），第三时区为 +2 小时（+120 分钟），均相对 UTC。",
            "changeExample": "若要将第二时区改为 +6 小时，第一个值应为 360（6×60）。结合上例则结果为：",
            "advancedTitle": "高级选项（A/B/C 后缀）",
            "advancedOptionalHint": "本节为可选。仅当表盘支持 A/B/C 格式后缀时相关。",
            "advancedIntro": "表盘是否支持这些后缀，见表盘设置中偏移字段上方的说明。若支持，可能看到类似说明：",
            "advancedExample": "UTC 第二、第三时区偏移（分钟，空格分隔）（偏移后字母：A=12 小时制，B=24 小时制，C=军用格式，空=默认）",
            "advancedNote": "这些可选字母（A/B/C）在部分表盘中控制对应时区的显示格式。仅当表盘说明中提及时使用。",
            "exampleSectionTitle": "分步示例：不同城市与格式",
            "exampleIntro": "以下示例说明如何设置第二时区（如纽约）和第三时区（如东京），以及可选地为各时区选择 12 小时/24 小时显示。",
            "exampleStep1Title": "步骤 1：第二时区 UTC 偏移",
            "exampleStep1Text": "选定第二时区的城市或地区，将其与 UTC 的时差换算为分钟。例如：纽约（EST，UTC−5）→ −300 分钟。将该值作为第一项输入到字段中。",
            "exampleStep2Title": "步骤 2：第三时区 UTC 偏移",
            "exampleStep2Text": "第三时区同理。例如：东京（JST，UTC+9）→ 540 分钟。为第二项，与第一项用空格分隔。",
            "exampleOnlyOffsets": "若表盘不使用 A/B/C 后缀，到此即可。输入：",
            "exampleStep3Title": "步骤 3：可选格式后缀（A/B/C）",
            "exampleStep3Optional": "此步骤可选：即使表盘支持后缀也可省略，此时使用默认格式。若需为某时区指定 12 小时、24 小时或军用格式，请在偏移后紧跟字母，偏移与后缀之间不要加空格。",
            "exampleStep3Text": "示例：纽约 12 小时制（A）、东京 24 小时制（B）：",
            "exampleStep3Note": "无后缀 = 表盘默认（多为 24 小时）。是否支持后缀见表盘设置中偏移字段上方的说明。",
            "exampleFormatTitle": "A、B、C 下的时间显示方式",
            "exampleFormatIntro": "同一时刻因格式不同显示不同（如第二时区纽约 -300，第三时区东京 540）。实时预览：",
            "zone2": "第二时区",
            "zone3": "第三时区",
            "exampleTableTitle": "参考：部分城市 UTC 偏移（分钟）",
            "exampleTableIntro": "标准时间；夏令时可能不同。将小时数乘以 60。"
        },
        "switchViews": {
            "title": "切换视图与手势控制",
            "wordLabel": "切换视图",
            "basicsTitle": "什么是切换视图？",
            "basicsText": "许多表盘可在同一屏幕区域显示不同信息，这些替代页面在设置中常称为「Switchview」（{{wordLabel}}）、「Switchview 2」、「顶部视图 1/2」、「底部视图 1/2」等。",
            "proNote": "这些额外视图多为专业功能，试用期内可用，之后需激活密钥。",
            "gestureTitle": "用手腕手势切换视图",
            "gestureIntro": "在不支持触屏的手表上，可通过第二次抬腕动作切换替代视图。",
            "gestureStep1": "像平时一样抬腕唤醒屏幕。秒数或变亮的屏幕表示处于活动模式。",
            "gestureStep2": "在几秒内（约 7 秒）再次做抬腕动作——不要太猛，但要足够清晰以便手表识别。",
            "gestureStep3": "若表盘支持切换视图，已配置区域（如顶部/底部视图）会切换到下一页。",
            "gestureHint": "若没有变化，请检查设置：部分视图需显式指定（如「顶部视图 2」/「底部视图 2」）。",
            "touchTitle": "触屏设备上的切换视图",
            "touchIntro": "在支持触屏的新款手表（如 Fenix 7 及更新）上，通常也可通过点击特定触控区域切换视图。",
            "touchConfig": "许多表盘可在设置中配置这些区域，往往在列表靠下。典型例子是时间的小时、分钟数字或屏幕上的独立区域。",
            "touchHold": "若已配置触控区域，长按对应数字/区域即可切换所分配的视图。",
            "touchMultiple": "部分表盘提供多个可分别分配的触控区，例如一个管顶部视图、一个管底部视图。",
            "touchInfo": "若某表盘有特殊触控区，通常会在本站或 ConnectIQ 商店的表盘说明中描述。"
        },
        "findWfId": {
            "title": "如何找到您的 WatchfaceID",
            "whatIs": "什么是 WatchfaceID？",
            "whatIsExplanation": "每个表盘在每台设备上有唯一的 WatchfaceID，为 5–6 位数字。购买激活码或寻求支持时需要此 ID。",
            "connectIqTitle": "通过 ConnectIQ 应用（推荐）",
            "ciq1": "确保手表已通过蓝牙与手机连接。",
            "ciq2": "在手机上打开 ConnectIQ 应用。",
            "ciq3": "进入可看到描述和图片的表盘页面。若找不到，可使用底部「搜索」栏或在「设备」下的「我的表盘」中查找。",
            "ciq4": "在表盘页面点击「设置」按钮以打开全部设置。",
            "ciq5": "WatchfaceID 显示在顶部字段。复制或输入该数字，即为支付所需 ID。",
            "keyEntryTitle": "输入激活密钥",
            "keyEntryExplanation": "WatchfaceID 字段下方一行是支付后发送的密钥/代码输入栏。部分表盘在此显示剩余试用天数，输入密钥前请先删除。",
            "garminExpressTitle": "通过 Garmin Express（电脑端）",
            "ge1": "安装 Garmin Express 并将手表连接到电脑。",
            "ge2": "进入已安装表盘列表。",
            "ge3": "点击表盘项旁的三点按钮打开设置。",
            "ge4": "步骤与 ConnectIQ 应用相同。",
            "geNote": "说明：推荐使用 ConnectIQ 应用，部分 Garmin Express 版本可能出错。",
            "zeroId": "WatchfaceID 显示为 0？",
            "zeroIdExplanation": "有时 WatchfaceID 会显示 0。通常保存一次设置或重启手表即可恢复。若仍为 0，一般仍可用于支付。"
        },
        "location": {
            "title": "GPS 与位置设置",
            "whatIsGpsFix": "什么是 GPS 定位？",
            "gpsFixExplanation": "GPS 定位让表盘知道您的位置，从而正确计算日出/日落时间、月相、天气位置和潮汐。",
            "howTo": "如何进行 GPS 定位",
            "step1": "在手表上进入任意活动的开始界面（如「跑步」）",
            "step2": "等待手表获得 GPS 信号（绿色条/图标）",
            "step3": "返回表盘——数据应在几分钟内更新",
            "alternative": "替代方式：手机 GPS",
            "alternativeExplanation": "也可在手机上开启 GPS。手表需通过蓝牙连接。此方式较慢但同样有效。",
            "requirements": "要求",
            "req1": "手表通过蓝牙与手机连接",
            "req2": "Garmin Connect 应用（非 ConnectIQ）至少在后台运行",
            "req3": "使用手机定位时需在手机上开启 GPS"
        },
        "settings": {
            "tabs": { "options": "数据字段选项", "change": "更改设置", "troubleshoot": "故障排除" },
            "title": "表盘设置",
            "optionsIntro": "所有数据字段选项的通用列表。点击可查看说明。并非所有表盘都提供所有选项。",
            "change": {
                "title": "如何更改表盘设置",
                "intro": "表盘设置可通过手机上的 ConnectIQ 应用更改。",
                "step1": "通过蓝牙将手表与手机连接，并打开 ConnectIQ 应用（不是 Connect）。",
                "step2": "进入表盘页面。若尚未安装，请先安装。",
                "step3": "在表盘页面点击「设置」按钮即可打开设置列表。",
                "step4": "此处可更改所有数据字段、颜色和高级选项。",
                "step5": "点击右上角保存按钮将设置传输到手表。",
                "installLink": "安装指南"
            },
            "troubleshoot": {
                "title": "故障排除",
                "cantSave": { "q": "无法保存设置", "a1": "有时 Garmin 服务器无法处理某些字符。", "a2": "清空颜色主题字段（如有）后再次保存。" },
                "wontOpen": { "q": "设置无法打开", "a1": "完全关闭 ConnectIQ 应用，必要时重启手表。", "a2": "若只看到「安装」按钮，说明表盘尚未安装。" },
                "missingOptions": { "q": "找不到某项设置", "a": "并非所有设备都提供所有选项。" },
                "naValue": { "q": "某字段只显示「n/a」", "a": "您的设备不支持该选项（机型较旧或缺少硬件）。" }
            }
        },
        "dateFormat": {
            "title": "自定义日期格式（日期 1 / 2 / 3）",
            "basicsTitle": "日期格式字段是什么？",
            "basicsIntro": "表盘设置中有两个（或三个）字段用于配置日期 1、日期 2 及（若支持）日期 3 的显示方式。输入的字母决定格式。",
            "notAll": "并非所有表盘都支持。",
            "where": "日期格式配置字段通常位于设置列表较下方、数据字段选项之下。",
            "codesTitle": "格式代码",
            "codesIntro": "格式字段可使用以下字母。输出反映当前日期。",
            "codeD": "日（月内，带前导零）",
            "codeDText": "星期（如：星期一）",
            "codeM": "月（数字，带前导零）",
            "codeMText": "月（文本）",
            "codeY": "年（两位）",
            "codeY4": "年（四位）",
            "codeJ": "儒略日（军用）",
            "codeW": "周数",
            "codeO": "月（无前导零）",
            "codeN": "日（无前导零）",
            "codeP": "年内第几天",
            "exampleHint": "例：「D, d.M.Y」可显示「周一, 27.02.2026」。"
        }
    },
    "themeInfo": {
        "howDoThemesWork": {
            "title": "主题如何工作？：",
            "description": "表盘设置顶部有一个「主题字符串」，代表当前颜色设置（图标、图表、时间等）。若修改某项（如顶部区域颜色）并点击「保存」，下次打开设置时主题字符串会自动更新。这样您可通过复制并保存主题字符串来备份颜色配置，也可在评论/论坛中与他人分享，或应用他人的主题字符串尝试不同风格。"
        },
        "dynamicThemeSwitching": {
            "title": "动态主题切换：",
            "sunset": {
                "title": "日落之后 / 日出之前切换 -",
                "description": "在主题字符串字段中，在要切换到的主题字符串前加感叹号 !，即会保存为日落后切换的主题（示例：!UEUE[UEUEEEEEEU^）。可随时在字段中输入以 ! 开头的主题字符串进行修改。若要去掉夜间主题，只需在字段中输入单独的 !，即不再切换。"
            },
            "lowPower": {
                "title": "低功耗模式下切换 -",
                "description": "与上面设置日落/日出主题的过程相同，但将主题字符串前的 ! 改为 #（示例：#UEUE[UEUEEEEEEU^）。手表在您看表或从菜单返回约 10 秒后进入「低功耗模式」。通常低功耗下秒数会消失（可在表盘设置中更改）。两种切换（@夜间/@低功耗）可同时使用。设置后动态主题字符串不会在表盘设置中显示，若日后可能修改请另行保存。"
            }
        }
    },
    "helpCenter": {
        "title": "帮助与说明",
        "subtitle": "表盘相关的答案、指南与说明",
        "guidesTitle": "指南与说明",
        "faqTitle": "常见问题",
        "allCategories": "全部",
        "guides": "指南",
        "faqResults": "FAQ",
        "noResults": "未找到结果",
        "noResultsHint": "请尝试其他关键词或浏览下方分类与指南。"
    },
    "watchfacesOverview": {
        "title": "所有应用",
        "loading": "正在加载表盘...",
        "error": "加载表盘出错",
        "retry": "重试",
        "noWatchfaces": "暂无可用表盘"
    },
    "detailTabs": {
        "payment": "支付",
        "themes": "主题",
        "info": "信息",
        "instructions": "说明",
        "instructionsIntro": "所有指南与说明一览：",
        "noThemes": "此表盘暂无颜色主题。"
    },
    "watchfaceDetail": {
        "loading": "正在加载表盘...",
        "error": {
            "notFound": "未找到表盘",
            "loading": "加载表盘出错"
        },
        "backToOverview": "返回列表",
        "goToStore": "前往 IQ Store",
        "goToTrial": "试用版",
        "devices": "设备",
        "info": {
            "title": "功能",
            "tides": "🌊 潮汐信息（自动更新）",
            "weather": "🌤️ OpenWeatherMap 与 Yr 天气数据",
            "colors": "🎨 颜色主题与自定义",
            "location": "📍 基于 GPS 的位置",
            "faq": "❓ 常见问题与支持",
            "weatherFallback": "未订阅 One Call 3.0 时，OpenWeatherMap API 密钥将回退到「Yr」天气提供商。"
        }
    },
    "colorThemes": {
        "clickToCopy": "点击复制",
        "clickToPreview": "点击预览",
        "closePreview": "关闭预览",
        "copied": "已复制！",
        "useInSettings": "在表盘设置中使用",
        "guideLink": "关于主题与主题字符串的更多说明",
        "deviceNote": "颜色主题并非在所有设备上可用。",
        "noFieldNote": "如果您的表盘设置中没有单独的颜色方案字段，则表示此表盘不支持您的手表型号的颜色主题。"
    },
    "payment": {
        "option1": {
            "title": "选项 1：Garmin Pay",
            "description": "在 ConnectIQ Store 通过 Garmin Pay 购买付费表盘（若您的手表支持）。",
            "link": "ConnectIQ Store 链接"
        },
        "option2": {
            "title": "选项 2：通过 WatchfaceID 直接支付",
            "description": "若您的手表不支持 Pro 版，可输入 WatchfaceID 购买试用/VX 版密钥。",
            "vxNote": "此为表盘 VX 版密钥，非 Garmin Pay 版！",
            "vxLink": "VX 版链接"
        },
        "tax": "税费",
        "wfid": {
            "description": "输入您的 WatchfaceID（在表盘设置中可查）",
            "placeholder": "输入 WatchfaceID（5–6 位数字）",
            "guideLink": "如何查找 WatchfaceID",
            "guideLinkShort": "显示说明"
        },
        "wfidError": {
            "letters": "WatchfaceID 只能包含数字",
            "tooLong": "WatchfaceID 应为 5–6 位",
            "invalid": "请输入有效的 WatchfaceID（5–6 位数字）",
            "lengthHint": "WatchfaceID 通常为 5–6 位数字，请核对。"
        },
        "errors": {
            "empty": "请输入 WatchfaceID",
            "invalid": "请输入有效的 WatchfaceID",
            "config": "支付配置错误",
            "checkout": "无法打开支付，请重试。"
        },
        "buy": "立即购买",
        "selectMethod": "选择您的版本",
        "versionSelectHint": "这是两个独立的版本 — 请选择正确的版本：",
        "vxWarning": "VX版和Elite版是各自独立可下载的表盘版本。VX版的激活码不能解锁Elite版本。",
        "beta": {
            "title": "当前为测试版",
            "description": "在测试阶段内，您可以完全免费使用此表盘。测试结束后也不会自动扣费。当前我们正在测试新的功能和改进。感谢您的反馈！",
            "descriptionApp": "在测试阶段内，您可以完全免费使用此应用。测试结束后也不会自动扣费。当前我们正在测试新的功能和改进。感谢您的反馈！"
        },
        "elite": {
            "badge": "Garmin Pay",
            "title": "Elite 版",
            "description": "此表盘仅可通过 ConnectIQ Store 的 Garmin Pay 购买。",
            "comboDescription": "在 ConnectIQ Store 通过 Garmin Pay 购买，为独立版本。",
            "compatibility": "并非所有手表都支持 Garmin Pay，请在商店页查看设备兼容性。否则请下载 VX 版（功能相同）。",
            "storeLink": "在 ConnectIQ Store 中打开",
            "moreGuide": "需要了解 Elite 与 VX 版的区别？",
            "moreGuideLink": "阅读购买与安装指南",
            "eliteNoKey": "通过 Garmin Pay 购买 Elite 版时不会发送解锁码。Elite 版在购买后直接解锁，无需输入代码。",
            "accountBound": "通过 Garmin Pay 购买绑定到您的 Garmin 账户，自动适用于您未来的设备（如果兼容）。",
            "eliteNoKeyAndGuide": "通过 Garmin Pay 购买时不会发送解锁码 — Elite 版在购买后直接解锁。更多详情请参阅购买与安装指南。"
        },
        "vx": {
            "badge": "所有设备",
            "title": "VX 版",
            "description": "兼容所有支持的设备。从 ConnectIQ Store 下载免费试用版，然后在此用购买的激活码激活。",
            "trialNote": "VX 版含试用期。试用结束后可在下方购买激活码以永久解锁。",
            "deviceBound": "激活码绑定到您的设备，永久解锁 VX 版。",
            "moreGuide": "需要了解 VX 版、密钥或安装的更多说明？",
            "moreGuideLink": "阅读购买与安装指南",
            "downloadLink": "下载 VX 版",
            "details": {
                "line1": "支付成功后，激活密钥将发送到您在下一步填写的邮箱。",
                "line2": "请确保邮箱地址正确。",
                "line3": "支付成功后请查看垃圾邮件文件夹，密钥邮件常会进入该处。",
                "line4": "所有支付由 Paddle 处理，无需注册账号。",
                "line5": "如需支持，请使用联系表单或 ConnectIQ Store 工具。",
                "line6": "其他咨询无法处理。"
            }
        },
        "standalone": {
            "title": "购买激活码",
            "description": "在下方输入您的 WatchfaceID 购买激活码，激活码将立即发送给您。"
        },
        "checkoutOpening": "正在打开支付...",
        "info": {
            "key": "购买后您将收到可在表盘设置中输入的密钥。",
            "activation": "密钥将在支付成功后立即激活。",
            "support": "如有疑问请联系支持。",
            "moreGuide": "更多关于购买与安装的说明"
        },
        "methods": {
            "applePay": "Apple Pay",
            "googlePay": "Google Pay",
            "alipay": "Alipay",
            "paypal": "PayPal",
            "creditCard": "信用卡"
        }
    },
    "footer": {
        "tagline": "现代 Garmin 应用，功能强大，适用于所有活动。",
        "description": "现代 Garmin 应用，功能强大，适用于所有活动。"
    },
    "newsletter": {
        "title": "邮件订阅",
        "description": "订阅邮件以获取新表盘、功能与优惠信息。",
        "frequencyHint": "约每两个月一封邮件，可随时退订。",
        "emailPlaceholder": "您的邮箱地址",
        "subscribe": "订阅",
        "unsubscribe": "退订",
        "subscribeSuccess": "订阅成功！请查收邮件。",
        "subscribeError": "发生错误，请稍后再试。",
        "unsubscribeSuccess": "已退订。",
        "unsubscribeError": "发生错误，请稍后再试。"
    },
    "contact": {
        "title": "联系",
        "description": "有问题或需要支持？可以给我发送一条消息。",
        "emailLabel": "邮箱",
        "emailPlaceholder": "you@email.cn",
        "deviceLabel": "设备（可选）",
        "devicePlaceholder": "例如：Fenix 7",
        "watchfaceLabel": "表盘（可选）",
        "watchfacePlaceholder": "例如：Horizon",
        "messageLabel": "消息",
        "messagePlaceholder": "你的消息...",
        "send": "发送消息",
        "sendAnother": "再发一条消息",
        "successTitle": "消息已发送！",
        "successMessage": "我会尽快回复你。",
        "error": "发生错误。请重试，或者直接发送邮件到 dev@orcatec.net。",
        "rateLimit": "每5分钟最多发送2条消息。请稍后再试。",
        "consentNotice": "提交即表示你同意按我的以下条款处理你的数据：",
        "guidesIntro": "如果你对某些具体功能有疑问，下列使用说明中也许已经有详细解答：",
        "faqIntro": "此外，很多主题在常见问题（FAQ）中也有更详细的说明：",
        "faqLinkLabel": "打开帮助与说明",
        "responseTimeNotice": "请理解：在比较忙的时期，回复时间有时可能需要几天。"
    },
    "fonts": {
        "title": "字体",
        "timefonts": "时间字体",
        "datafonts": "数据字体"
    },
    "common": {
        "loading": "加载中...",
        "error": "错误",
        "retry": "重试",
        "back": "返回",
        "close": "关闭",
        "save": "保存",
        "cancel": "取消",
        "confirm": "确认",
        "notFound": "404 – 页面未找到"
    },
    "bierwander": {
        "title": "Bierwandern",
        "intro": "Bierwandern 应用可记录你的徒步以及沿途享受的续杯。此外还提供血液酒精估算和图表（粗略估计）——但请不要太当真！",
        "settingsHint": "在开始界面按手表上的菜单按钮进入设置（双按钮布局的手表请长按触摸屏）。",
        "disclaimer": "酒精含量计算纯属娱乐指标——根据饮用的饮料和体重估算血液酒精的算法！请勿根据该数值做任何决定——它不可靠，也不是真实的酒精测量！",
        "closing": "祝你徒步愉快，玩得开心！",
        "support": "如有问题或改进建议，请使用「App Support」按钮——谢谢。"
    },
    "bodysurf": {
        "intro": {
            "title": "什么是 BodySurf？",
            "text": "BodySurf 是一款用于趴板冲浪的 Garmin Connect IQ 手表应用。它使用 GPS 检测乘浪，测量每次滑行的距离和时长，并根据距离授予趣味称号。会话会作为活动保存到 Garmin Connect，每次滑行记为一圈。"
        },
        "gps": {
            "title": "开始前 – GPS",
            "text1": "开始会话前请等待 GPS 定位。开始界面会先显示“正在搜索GPS”，有信号后显示“按START开始”。",
            "text2": "为获得最佳精度，在支持的表款上使用多 GNSS / 双频 GPS。若定位较慢，请在水边静止片刻。"
        },
        "start": {
            "title": "开始屏幕",
            "startBtn": "GPS 就绪后开始新会话（START = 开始会话）。",
            "menuBtn": "打开设置：如何使用 和 单位（MENU = 设置 / 信息）。",
            "backBtn": "BACK = 退出应用"
        },
        "during": {
            "title": "活动期间",
            "detect": "骑行通过GPS检测速度自动。使用BACK手动开始/停止骑行。不足约 2 米的短距离移动会被忽略。",
            "startBtn": "START = 停止 / 保存 / 继续",
            "backBtn": "BACK = 手动骑行开/关",
            "live": "滑行时显示当前距离、实时称号和“骑行中！”。一次滑行结束后，称号和统计会保留到下一次滑行开始。"
        },
        "stop": {
            "title": "停止菜单",
            "resume": "继续",
            "save": "保存",
            "discard": "放弃"
        },
        "after": {
            "title": "会话结束后",
            "summary": "摘要显示会话时间、骑行记录 次数、总距离，以及最佳滑行及称号与统计。",
            "rides": "滑动查看骑行详情。按键手表请用 << DOWN rides。",
            "finished": "之后：START 新会话，BACK 退出应用。"
        },
        "titles": {
            "title": "滑行称号",
            "intro": "每次骑行都有一个有趣的标题基于距离。骑行越长标题越好！",
            "colDistance": "距离",
            "colTitle": "称号",
            "th0": "海黄瓜",
            "th1": "比目鱼",
            "th2": "人类冲浪板",
            "th3": "浪潮骑士",
            "th4": "海王",
            "th5": "波塞冬",
            "th6": "海神",
            "th7": "浪潮征服者",
            "th8": "骑士大师",
            "th9": "浪潮之神",
            "th10": "海洋传奇",
            "th11": "浪潮泰坦",
            "th12": "海洋之王"
        },
        "connect": {
            "title": "Garmin Connect",
            "text": "已保存的会话在 Garmin Connect 中显示自定义字段：滑行称号、单圈距离（米）、单圈时间（秒）及会话级最长滑行/时间。每次检测到的滑行保存为一圈。"
        },
        "instinct": {
            "title": "Instinct 2 / 3 (MIP)",
            "layout": "Instinct 上副屏显示时间、GPS 和滑行距离。用 DOWN 键代替滑动（<< DOWN rides）。",
            "menu": "开始界面左侧显示“菜单”。副屏显示 GPS正常 时 按下START。"
        },
        "settings": {
            "title": "设置",
            "units": "单位：在手表上切换距离和速度的单位（公制/英制）。",
            "info": "信息：手表内置帮助（如何使用），说明活动中、会话后和开始界面的按键。"
        },
        "supportBefore": "如有问题或建议，请使用",
        "supportLink": "联系表单",
        "supportAfter": "。"
    }
};
